module.exports = __webpack_public_path__ + "static/img/547f3de8cdef45698732ddad367617d7.1954120a.jpg";